import type { SVGProps } from 'react';

const SvgRangeInPoint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M13 20c-.55 0-1-.45-1-1v-4.59l-1.71-1.71a.996.996 0 0 1 0-1.41L12 9.58V4.99c0-.55.45-1 1-1s1 .45 1 1v5c0 .27-.11.52-.29.71l-1.29 1.29 1.29 1.29c.19.19.29.44.29.71v5c0 .55-.45 1-1 1z"
    />
  </svg>
);
export default SvgRangeInPoint;
